// Přepínač firmy v horním panelu.
// (Krok B1b: rozděleno ze src/app.js beze změny kódu; importy/exporty doplněny automaticky.)
import { esc, queueWrite, saveCurrentCompanyId, showToast, sortedCompanies, state } from '../core/state.js';
import { db } from '../core/boot.js';
import { allResultItems, auditTypeEval, auditUsesOkNok, clearDraftBackup, incompleteFindingsCount, missingCorrectiveCount } from './audit-runner.js';
import { render } from '../main-render.js';

// ================= COMPANY SWITCHER (právní subjekty) =================
function renderCompanySwitcherOverlay(){
  var root = document.getElementById('overlayRoot');
  var list = sortedCompanies();
  var html = '<div class="overlay company-switch-overlay" onclick="App.closeCompanySwitcher(event)">' +
    '<div class="sheet" onclick="event.stopPropagation()">' +
    '<div class="sheet-head"><h3>Právní subjekty</h3><button class="icon-btn" onclick="App.closeCompanySwitcher()">×</button></div>' +
    '<div>';
  if(list.length===0){
    html += '<p class="muted" style="font-size:var(--fs-md)">Zatím žádný právní subjekt.</p>';
  } else {
    list.forEach(function(e){
      var id = e[0], c = e[1];
      var active = id===state.currentCompanyId;
      html += '<button class="company-switch-item'+(active?' on':'')+'" onclick="App.switchCompany(\''+id+'\')">' +
        '<span>'+esc(c.name||'(bez názvu)')+'</span>' + (active?'<span class="chk">✓</span>':'') + '</button>';
    });
  }
  html += '</div>';
  // Nový subjekt jen v Nastavení → Správa systému → Firmy (rozhodnutí uživatele).
  html += '</div></div>';
  root.innerHTML = html;
}
App.openCompanySwitcher = function(){
  renderCompanySwitcherOverlay();
};
App.closeCompanySwitcher = function(ev){
  if(ev) ev.stopPropagation();
  document.getElementById('overlayRoot').innerHTML = '';
};
App.switchCompany = function(id){
  if(id!==state.currentCompanyId) state.placeSearch = {};
  state.currentCompanyId = id;
  saveCurrentCompanyId(id);
  App.closeCompanySwitcher();
  render();
};

App.closeAudit = function(){
  var a = state.draftAudit;
  if(!a || !db) return;
  if(missingCorrectiveCount(a.answers)>0){
    showToast('Doplňte nápravné opatření u všech NOK otázek.');
    render();
    return;
  }
  if(incompleteFindingsCount(a.findings)>0){
    showToast('Doplňte u zjištění popis, u neshody i odpovědnou osobu a termín.');
    render();
    return;
  }
  var ok=0, nok=0, na=0;
  allResultItems(a.answers).forEach(function(r){ if(r==='OK')ok++; else if(r==='NOK')nok++; else if(r==='NA')na++; });
  // Neshody z volných zjištění se počítají do výsledku OK/NOK (závada je
  // závada), do skóre (podíl otázek OK) ne.
  var findings = (a.findings||[]).map(function(f){
    if(f.result==='NOK' && f.correctiveAction && !(f.correctiveAction.description||'').trim()){
      f.correctiveAction.description = (f.note||'').trim(); // opatření bez popisu = popis neshody
    }
    return f;
  });
  var fNok = findings.filter(function(f){ return f.result==='NOK'; }).length;
  var fGood = findings.length - fNok;
  var nokThreshold = auditTypeEval(a.auditTypeId).threshold;
  var summary = {ok:ok, nok:nok, na:na, nokThreshold:nokThreshold, overall: (nok+fNok)>=nokThreshold ? 'NOK' : 'OK', findingsNok:fNok, findingsGood:fGood};
  var closedAt = new Date().toISOString();
  queueWrite(function(){
    return db.doc('audits/'+a.id).update({status:'closed', closedAt:closedAt, summary:summary, answers:a.answers, findings:findings}).then(function(){
      showToast(auditUsesOkNok(a) ? 'Audit uzavřen: ' + (summary.overall==='OK'?'OK':'NOK') : 'Audit uzavřen.');
      clearDraftBackup(a.id);
      state.activeAuditId = null;
      state.draftAudit = null;
      state.view = 'history';
      state.historyFilterWp = a.workplaceId;
      state.historyDetailId = null;
      render();
    });
  });
};
